import { ApiError } from '@/lib/errors';

const AC_IMPORT_ERROR_MESSAGES: Record<string, string> = {
  not_connected:
    'ActiveCampaign isn’t connected. Please reconnect and try again.',
  unknown_list: 'That list no longer exists in ActiveCampaign – pick another.',
  ac_auth_failed: 'ActiveCampaign isn’t fully configured; please reconnect.',
  rate_limited:
    'ActiveCampaign is rate limiting requests – please retry shortly.',
  ac_unreachable: 'Couldn’t reach ActiveCampaign – please retry.',
  invalid_request: 'That value isn’t valid – check it and try again.',
};

const DEFAULT_AC_IMPORT_ERROR_MESSAGE =
  'Something went wrong. Please try again.';

export function getAcImportErrorMessage(error: unknown): string {
  const code =
    error instanceof ApiError
      ? (error.response as { error_code?: string } | undefined)?.error_code
      : undefined;
  return (
    (code && AC_IMPORT_ERROR_MESSAGES[code]) || DEFAULT_AC_IMPORT_ERROR_MESSAGE
  );
}
